<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <title-text />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <slug-text />
        </b-col>
        <b-col
          cols="12"
        >
          <b-form-group
            label="Sektör Bilgisi"
            label-for="id_sectors"
          >
            <v-select
              id="id_sectors"
              v-model="dataItem.id_sectors"
              :options="sectors"
              label="title"
              :reduce="item => item.id"
              placeholder="Sektör Bilgisi"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-button
      variant="primary"
      @click="submitForm"
    >
      Kaydet
    </b-button>

  </div>

</template>

<script>
import {
  BCard,
  BFormInput, BFormGroup, BRow, BCol, BButton,
} from 'bootstrap-vue'

import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import TitleText from '@/views/Admin/ReferencesTypes/elements/Title.vue'
import SlugText from '@/views/Admin/ReferencesTypes/elements/Slug.vue'

export default {
  name: 'ItemForm',
  components: {
    BButton,
    TitleText,
    vSelect,
    BFormGroup,
    BFormInput,
    ValidationProvider,
    BCard,
    BRow,
    BCol,
    SlugText,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    sectors() {
      return this.$store.getters['sectors/dataList']
    },
    dataItem() {
      return this.$store.getters['references_types/dataItem']
    },

  },
  created() {
    this.getSectors()
  },
  methods: {
    getSectors() {
      this.$store.dispatch('sectors/getDataList', {
        select: [
          'sectors.id AS id',
          'sectors.title AS title',
        ],
      })
    },

  },
}
</script>
